<template>
  <div>
    <v-dialog v-model="dialog" max-width="500px">
      <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">Nueva Adquirencia</v-btn>
      </template>
      <v-layout row>
          <v-flex xs12>
              <v-card>
                  <progress-bar :show="form.busy"></progress-bar>
                  <form @submit.prevent="createAdquirencia" @keydown="form.onKeydown($event)">
                      <v-card-title primary-title>
                          <h3 v-if="!editingAcquisition" class="headline mb-0">{{ $t('payments.acquisition.create_title') }}</h3>
                          <h3 v-else class="headline mb-0">{{ $t('payments.acquisition.edit_title') }}</h3>
                      </v-card-title>

                      <v-card-text>

                        <text-input
                            :form="form"
                            :label="$t('payments.acquisition.payment_method_id')"
                            :v-errors="errors"
                            :value.sync="form.payment_method_id"
                            name="payment_method_id"
                            v-validate="'required'"
                        ></text-input>

                        <text-input
                            :form="form"
                            :label="$t('payments.acquisition.description')"
                            :v-errors="errors"
                            :value.sync="form.description"
                            name="description"
                        ></text-input>

                        <v-text-field
                            ref="price"
                            :form="form"
                            :label="$t('payments.acquisition.price')"
                            :v-errors="errors"
                            :value.sync="form.price"
                            name="price"
                            v-validate="'required'"
                            v-model="form.price"
                            @keypress="onlyNumbers"
                        ></v-text-field>

                        <check-input
                          name="status"
                          :form="form"
                          :label="$t('payments.acquisition.status')"
                          :value.sync="form.status"
                          :color="'primary'"
                          :v-errors="errors"
                        >
                        </check-input>

                      </v-card-text>

                      <v-card-actions>
                          <submit-button v-if="!editingAcquisition" :form="form" :label="$t('payments.acquisition.save-button')"></submit-button>
                          <submit-button v-else :form="form" :label="$t('payments.acquisition.update-button')"></submit-button>
                          <v-btn @click="clearForm" >{{ $t('payments.acquisition.cancel') }}</v-btn>
                      </v-card-actions>
                  </form>
              </v-card>
          </v-flex>
      </v-layout>
    </v-dialog>
    <v-layout row>
      <v-flex xs12 >
        <v-data-table
          :headers="headers"
          :items="acquisitions"
          class="elevation-1 mt-3"
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">{{ props.item.payment_method_id }}</td>
            <td class="text-xs-center">{{ props.item.description }}</td>
            <td class="text-xs-center">{{ props.item.price }}</td>
            <td class="text-xs-center">{{ props.item.status == 1 ? 'Si' : 'No' }}</td>
            <td>
              <v-tooltip top>
                <v-icon
                  medium
                  class="mr-2"
                  @click="editAcquisition(props.item.id)"
                  slot="activator"
                >
                  edit
                </v-icon>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip top>
                <v-icon
                  medium
                  class="mr-2"
                  @click="deteleAcquisition(props.item.id)"
                  slot="activator"
                >
                  delete
                </v-icon>
                <span>Eliminar</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
    import Form from 'vform';
    import axios from 'axios';
    import { VMoney } from 'v-money'


    export default {
        name: 'payment-acquisitions-create-view',

        data() {
          return {
            form: new Form({
                price: '',
                payment_method_id: '',
                description: '',
                status: true,
            }),
            acquisitions: [],
            money: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 0,
                masked: false
            },
            headers: [
              { text: this.$t('payments.acquisition.payment_method_id'), align: 'center', value: 'payment_method_id' },
              { text: this.$t('payments.acquisition.description'), align: 'center', value: 'description' },
              { text: this.$t('payments.acquisition.price'), align: 'center', value: 'price' },
              { text: this.$t('payments.acquisition.status'), align: 'center', value: 'status', sortable: false },
              { text: this.$t('payments.acquisition.actions'), value: 'actions' }
            ],
            editingAcquisition: false,
            dialog: false
          }
        },
        directives: {money: VMoney},
        created() {
          this.init();
        },
        methods: {
            async init() {

              const resp = await axios.get('/api/payment/acquisitions');
              this.acquisitions = resp.data
            },
            async createAdquirencia() {
                if (await this.formHasErrors()) return
                if (this.editingAcquisition) {
                  this.updateAcquisitions();
                  return
                }

                const { data } = await this.form.post('/api/payment/acquisitions')

                if (data.created) {
                    this.$store.dispatch('responseMessage', {
                        type: 'success',
                        text: this.$t('payments.acquisition.stored-ok-text'),
                        title: this.$t('payments.acquisition.stored-ok-title'),
                        modal: false
                    })
                    this.clearForm()
                    this.init();
                } else {
                    this.$store.dispatch('responseMessage', {
                        type: 'warning',
                        text: this.$t('payments.acquisition.stored-error-text'),
                        title: this.$t('payments.acquisition.stored-error-title'),
                        modal: true
                    })
                }
            },
            async updateAcquisitions() {
              const { data } = await this.form.put('/api/payment/acquisitions')

                if (data.updated) {
                    this.$store.dispatch('responseMessage', {
                        type: 'success',
                        text: this.$t('payments.acquisition.stored-ok-text'),
                        title: this.$t('payments.acquisition.stored-ok-title'),
                        modal: false
                    })
                    this.init();
                    this.clearForm()
                } else {
                    this.$store.dispatch('responseMessage', {
                        type: 'warning',
                        text: this.$t('payments.acquisition.stored-error-text'),
                        title: this.$t('payments.acquisition.stored-error-title'),
                        modal: true
                    })
                }
            },
            onlyNumbers($event) {
                let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
                if(keyCode == 45) { //This is a code por - (minus sign)
                    $event.preventDefault();
                }
            },
            editAcquisition(id) {
              this.editingAcquisition = true
              const acquisitionToEdit = this.acquisitions.filter(acq => acq.id === id)[0]
              this.form = new Form({
                price: acquisitionToEdit.price,
                payment_method_id: acquisitionToEdit.payment_method_id,
                description: acquisitionToEdit.description,
                status: acquisitionToEdit.status == 1,
                id: acquisitionToEdit.id,
              })
              this.$refs.price.$el.getElementsByTagName('input')[0].value = acquisitionToEdit.price;
              this.dialog = true
            },
            deteleAcquisition(id) {
              axios.delete(`/api/payment/acquisitions/${id}`)
                .then(resp => {
                  if (resp.status === 200) {
                    this.acquisitions = this.acquisitions.filter(acq => acq.id !== id)
                  }
                })
                .catch(error => console.log(error))
            },
            clearForm() {
              this.dialog = false
              this.editingAcquisition = false
              this.form = new Form({
                price: '',
                payment_method_id: '',
                description: '',
                status: true,
              })
              this.$refs.price.$el.getElementsByTagName('input')[0].value = 0;
              this.form.price = 0
            }

        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/payment/acquisition.vue